import _uniq from "lodash/uniq";
/** @public */ export function uniq(array) {
    return _uniq(array);
}
